// extracted by mini-css-extract-plugin
export default {"wrapper":"Textarea_wrapper__XbT27","error":"Textarea_error__wHnOO","error-field":"Textarea_error-field__gIAS-"};